import { createSlice } from '@reduxjs/toolkit';

const initialState = {

    // domain settings
    domainSettingsLoading: true,
    domainSettingsError: null,
    domainSettings: null,            // { domain, callAssistantInstructions }

    // users list
    usersLoading: true,
    usersError: null,
    users: [],

    // domain usage snapshot (current month)
    domainUsageSnapshotLoading: true,
    domainUsageSnapshotError: null,
    domainUsageSnapshot: null,       // { analytics, callAssistant, chatAssistant }

    // domain usage history (all periods)
    domainUsageHistoryLoading: true,
    domainUsageHistoryError: null,
    domainUsageHistory: null,        // { analytics: [], callAssistant: [], chatAssistant: [] }

    // domain users usage snapshot (current month, all users)
    domainUsersUsageSnapshotLoading: true,
    domainUsersUsageSnapshotError: null,
    domainUsersUsageSnapshot: null,  // { users: [{ uid, analytics, callAssistant, chatAssistant }] }

    // domain users usage history (all periods, all users)
    domainUsersUsageHistoryLoading: true,
    domainUsersUsageHistoryError: null,
    domainUsersUsageHistory: null,   // { analytics: [], callAssistant: [], chatAssistant: [] }


};

export const analyticAdminSlice = createSlice({
    name: 'analyticAdmin',
    initialState,
    reducers: {
        // domain settings

        setDomainSettings: (state, action) => {
            state.domainSettingsLoading = false;
            state.domainSettingsError = null;
            state.domainSettings = action.payload;
        },
        updateDomainSettings: (state, action) => {
            state.domainSettingsLoading = false;
            state.domainSettingsError = null;
            if (state.domainSettings) {
                Object.assign(state.domainSettings, action.payload);
            } else {
                state.domainSettings = action.payload;
            }
        },

        // users

        setDomainUsers: (state, action) => {
            state.usersLoading = false;
            state.usersError = null;
            state.users = action.payload;
        },
        updateDomainUser: (state, action) => {
            const updated = action.payload;
            const index = state.users.findIndex((u) => u.uid === updated.uid);
            if (index !== -1) state.users[index] = updated;
        },

        // domain usage snapshot

        setDomainUsageSnapshot: (state, action) => {
            state.domainUsageSnapshotLoading = false;
            state.domainUsageSnapshotError = null;
            state.domainUsageSnapshot = action.payload;
        },

        // domain usage history

        setDomainUsageHistory: (state, action) => {
            state.domainUsageHistoryLoading = false;
            state.domainUsageHistoryError = null;
            state.domainUsageHistory = action.payload;
        },

        // domain users usage snapshot

        setDomainUsersUsageSnapshot: (state, action) => {
            state.domainUsersUsageSnapshotLoading = false;
            state.domainUsersUsageSnapshotError = null;
            state.domainUsersUsageSnapshot = action.payload;
        },

        // domain users usage history
        setDomainUsersUsageHistory: (state, action) => {
            state.domainUsersUsageHistoryLoading = false;
            state.domainUsersUsageHistoryError = null;
            state.domainUsersUsageHistory = action.payload;
        },
        resetAnalyticAdmin: () => initialState,
    },
});

export const {
    setDomainUsers,
    updateDomainUser,
    setDomainUsageSnapshot,
    setDomainUsageHistory,
    setDomainUsersUsageSnapshot,
    setDomainUsersUsageHistory,
    setDomainSettings,
    updateDomainSettings,
    resetAnalyticAdmin,
} = analyticAdminSlice.actions;

export const selectAdminState = (state) => state.analyticAdmin;

export default analyticAdminSlice.reducer;